<template>
  <div class="vw100 h750">
    <el-carousel ref="bannershow" loop height="39.0625vw" autoplay arrow="never" :interval="5000">
      <el-carousel-item v-for="(item,index) in banners" :key="index">
        <div class="w-vw100 column flex_center relative h750" @click.stop="toPath(item)">
          <div class="w-per100 h750">
            <img class="w-per100 h750" :src="getImageUrl(item.image)" alt="" />
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default{
  data(){
    return {
      
    };
  },
  computed: {
  ...mapGetters({
    banners:'indexBanner',
  })
},
  methods:{
    // 跳转
    toPath(item) {
      // console.log('b',item);
      // if(item.goods_id){
      //   // 跳转产品详情
      //   this.$router.push({
      //     path: "ProductDetail",
      //     query:{
      //       id:item.goods_id,
      //     }
      //   })
      // }else{
      //   // 外链
      //   if(item.url){
      //     window.location.href = item.url;
      //   }
      // }

      let u = item.url;
      let str = u.slice(u.indexOf('?')+1);
      let a = str.split('&');
      if(u.includes('/pages/index/index')){
        let p = {
          category_one:a[0]?a[0].slice(a[0].indexOf('=') + 1):0,
          category_two:a[1]?a[1].slice(a[1].indexOf('=') + 1):0,
        }
        let category_one = p.category_one?Number(p.category_one):0;
				let category_two = p.category_two?Number(p.category_two):0;
        this.$router.push({
          path:'/Search',
          query:{
            category_one:category_one,
            category_two:category_two,
          }
        })
      }else if(u.includes('/pagesIndex/goodsDetail/goodsDetail')){
        let id = a[0]?a[0].slice(a[0].indexOf('=') + 1):0;
        this.$router.push({
          path: "/Goods",
          query:{
            id:id,
          }
        })
      }else{
        if(u){
          window.location.href = item.url;
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-carousel__indicators{
  padding: 0;
  .el-carousel__indicator--horizontal{
    padding: 14px;
  }
  .el-carousel__button{
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #ffffff;
    opacity: 1;
  }
}
::v-deep .is-active{
  .el-carousel__button{
    background: #FF8E29;
    opacity: 1;
  }
}
@media screen and (min-width: 750px) and (max-width: 1250px){
::v-deep .el-carousel__indicators{
  .el-carousel__indicator--horizontal{
    padding: 8px;
  }
}
}
@media screen and (max-width: 750px){
::v-deep .el-carousel__indicators{
  padding: 0;
  .el-carousel__indicator--horizontal{
    padding: 4px;
  }
  .el-carousel__button{
    width: 8px;
    height: 8px;
  }
}
}
</style>